import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useAuth } from '@/shared/contexts/AuthContext';

const AuthRestrictedRoutes = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) return <div>Loading...</div>;

    // If logged in, redirect to dashboard
    if (user && user.emailVerified) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
};

AuthRestrictedRoutes.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AuthRestrictedRoutes;
